import { Alignment, Button, Displaying, Spacing, TRANSPARENT_COLOR, Typography } from "@bonusx-global/bx-design-system";
import { ChatsSolid } from "@bonusx-global/bx-icons";
import type { SxProps, Theme } from "@mui/system";

const chatbotPlaceholder = "Ultima chat";

const lastChatButtonContainerStyles: SxProps<Theme> = {
  display: Displaying.flex,
  flexDirection: "row",
  alignItems: Alignment.center,
  padding: `${Spacing[750]} ${Spacing[1000]}`,
  borderRadius: Spacing[750],
  border: `1px solid ${TRANSPARENT_COLOR}`,
  width: "fit-content",
  minWidth: "150px",
  maxWidth: "75%",
};

const lastChatButtonTextStyles: SxProps<Theme> = {
  flexGrow: 1,
  wordBreak: "break-word",
};

interface AiChatbotLastChatButtonProps {
  onClick?: () => void;
}

function AiChatbotLastChatButton({ onClick }: Readonly<AiChatbotLastChatButtonProps>): JSX.Element {
  return (
    <Button
      color="purpleLight"
      variant="contained"
      sx={lastChatButtonContainerStyles}
      startIcon={<ChatsSolid />}
      onClick={onClick}
    >
      <Typography variant="body1" sx={lastChatButtonTextStyles}>
        {chatbotPlaceholder}
      </Typography>
    </Button>
  );
}

export default AiChatbotLastChatButton;
